import { PostComposerFormState } from 'app/modules/posts/modules/post/components/composer/utils/postComposerFormState';
import { PostPreviewContent } from '@kontentino/kontentino-post-previews';
import DateUtils from 'app/utils/date';
import { PageNumberType } from '@kontentino/kontentino-constants/Pages';

export function getPostPreviewFromPostComposerForm(
  form: PostComposerFormState,
): PostPreviewContent {
  return {
    page: {
      id: form.page.id,
      name: form.page.name,
      type: form.page.type as PageNumberType,
      logo_src: form.page.logo?.src ?? null,
    },
    text: form.text,
    date: form.date ? DateUtils.toDateString(form.date) : null,
    time: form.time,
    type: form.type,
    attachments: form.attachments,
    id: form.id,
    subtype: form.subtype,
  };
}
